import axios from "axios";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { errorToastMsg, language } from "../helpers/Utils";
import { ORG_AUTH_REFRESH } from "../components/ApiConst";
import { HTTP_CODE } from "../pages/components/categoriesform/HttpCode";
// const location = useLocation();
//   let pathname = location.pathname;
// initiating base url
const API_URL = process.env.REACT_APP_API_URL;
var refreshToken = localStorage.getItem("ref_token")

export const headerDataTable = {
  "X-Authorization": ("Bearer " + localStorage.getItem("token")) as string,
  Authorization: "Basic cGVhcmxjb3JlOjVKS3p4UUQuNjddb0VTM3E=",
  "post-id": localStorage.getItem("post_id") as string,
  "session-id": localStorage.getItem("session_id") as string,
  "service-instance-id": localStorage.getItem(
    "service-instance-id"
  ) as string,
  region: "uk",
  organization: "eln",
}

const data = localStorage.getItem("persist:config");
// if (data) {
//   let config = JSON.parse(data);
//   let url = JSON.parse(config).base_url;
//   localStorage.setItem("base_url", url ? url : process.env.REACT_APP_API_URL);
// }
const Axios = axios.create({
  baseURL: API_URL + "/",
});
// request interceptor
Axios.interceptors.request.use(
  (config) => {
    const serviceInstanceId = localStorage.getItem("service-instance-id");
    const token = localStorage.getItem("token");
    const postId = localStorage.getItem("post_id");
    const sessionId = localStorage.getItem("session_id");

    config.headers = {
      ...config.headers,
      Authorization: "Basic cGVhcmxjb3JlOjVKS3p4UUQuNjddb0VTM3E=",
      "accept-language": language(),
    };

    if (token) {
      config.headers["X-Authorization"] = `Bearer ${token}`;
    }
    if (postId) config.headers["post-id"] = postId;
    if (sessionId) config.headers["session-id"] = sessionId;
    if (serviceInstanceId) config.headers["service-instance-id"] = serviceInstanceId;

    config.headers["region"] = "uk";
    config.headers["organization"] = "eln";

    return config;
  },
  (error) => Promise.reject(error)
);

// response interceptor
Axios.interceptors.response.use(undefined, (error) => {
  const statusCode = error.response ? error.response : null;
  statusResponse(statusCode);
  return Promise.reject(error);
});
// conditions for response statuses
export const statusResponse = (data: any) => {

  const refTokenHeader: any = {
    headers: {
      Authorization: "Basic " + localStorage.getItem("x-token"),
      "post-id": localStorage.getItem("post_id") as string,
      "session-id": localStorage.getItem("session_id") as string,
      "service-instance-id": localStorage.getItem(
        "service-instance-id"
      ) as string,
      region: "uk",
      organization: "eln",
    }
  }

  // if (data === 401) {
    // error status changed 
    if (data?.status === 401) {
    if (refreshToken !== null) {
      axios.create(refTokenHeader).post(ORG_AUTH_REFRESH, { refresh_token: refreshToken })
        .then((resp) => {
          if (resp.status == HTTP_CODE.OK) {

            localStorage.setItem("token", resp?.data?.data?.access_token);
            localStorage.setItem("ref_token", resp?.data?.data?.refresh_token);

          }
          else if (localStorage.getItem("token")) {
            localStorage.clear();
            window.location.href = "/";
          }
        })
        .catch((e) => {
          errorToastMsg(e.message);
          if (localStorage.getItem("token")) {
            localStorage.clear();
            window.location.href = "/";
          }
        })
    } else {
      errorToastMsg(data.data.error);
      if (localStorage.getItem("token")) {
        localStorage.clear();
        window.location.href = "/";
      }
    }
  }

  if (data?.status >= 500) {
    errorToastMsg(data.data.message);
  }
  if (data?.status === 400) {
    errorToastMsg(data.data.message);
  }
  if (data?.status === 402) {
    errorToastMsg(data.data.message);
  }
  if (data?.status === 424) {
    errorToastMsg(data.data.message);
  }
};
export default Axios;